<template>
  <div
    class="pr-[16px] md:pr-[24px]"
    :class="
      isBookmarkedPage
        ? 'w-full h-full mb-[32px] lg:w-[750px] lg-h-[300px] m-auto'
        : 'w-[288px] md:w-[288px] '
    "
    @click="openLanguageModal"
  >
    <!-- customClass="w-[288px] md:w-[288px] h-[162px] md:h-[162px] rounded-[16px]" -->
    <YoutubeInAppBrowser
      v-if="isYoutubeVideoLink(url)"
      :customClass="
        isBookmarkedPage
          ? 'w-full h-full mb-[32px] lg:w-[750px] lg-h-[300px] m-auto rounded-[16px]'
          : 'w-[288px] md:w-[288px] h-[162px] md:h-[162px] rounded-[16px]'
      "
      :video-id="getYoutubeId(url)"
      :video-url="url"
      :poster-url="imageUrl"
      :is-dark-button="true"
      :preferred-caption="null"
    />
    <router-link
      v-else-if="isNativeVideoLink(url) && resourceTranslations.length < 2"
      :to="
        isGICPage()
          ? `/gic/resources/video/${slug}`
          : isGPCRPage()
            ? `/gpcr/resources/video/${slug}`
            : `/resources/video/${slug}`
      "
    >
      <ResourceCardThumbnail
        :image-url="imageUrl"
        :type="type"
        :duration="duration"
        :slug="slug"
        :tag-slug="tagSlug"
        :isBookmarked="isBookmarked"
        :isBookmarkedPage="isBookmarkedPage"
      />
    </router-link>
    <in-app-browser
      v-else-if="(type === 'PDF' || type === 'Excel') && resourceTranslations.length < 2"
      download
      :href="url"
    >
      <ResourceCardThumbnail
        :image-url="imageUrl"
        :type="type"
        :duration="duration"
        :slug="slug"
        :tag-slug="tagSlug"
        :isBookmarked="isBookmarked"
        :isBookmarkedPage="isBookmarkedPage"
      />
    </in-app-browser>
    <in-app-browser
      v-else-if="type === 'sm_quotes' && resourceTranslations.length < 2"
      :href="imageUrl"
      target="_blank"
    >
      <ResourceCardThumbnail
        :image-url="imageUrl"
        :type="type"
        :duration="duration"
        :slug="slug"
        :tag-slug="tagSlug"
        :isBookmarked="isBookmarked"
        :isBookmarkedPage="isBookmarkedPage"
      />
    </in-app-browser>
    <router-link
      v-else-if="
        (type === 'sm_others' || type === 'sm_tools') &&
        isAppRoute(url) &&
        resourceTranslations.length < 2
      "
      :to="url"
    >
      <ResourceCardThumbnail
        :image-url="imageUrl"
        :type="type"
        :duration="duration"
        :slug="slug"
        :tag-slug="tagSlug"
        :isBookmarked="isBookmarked"
        :isBookmarkedPage="isBookmarkedPage"
      />
    </router-link>
    <in-app-browser v-else-if="resourceTranslations.length < 2" :href="url" target="_blank">
      <ResourceCardThumbnail
        :image-url="imageUrl"
        :type="type"
        :duration="duration"
        :slug="slug"
        :tag-slug="tagSlug"
        :isBookmarked="isBookmarked"
        :isBookmarkedPage="isBookmarkedPage"
      />
    </in-app-browser>
    <ResourceCardThumbnail
      v-else
      :image-url="imageUrl"
      :type="type"
      :duration="duration"
      :slug="slug"
      :tag-slug="tagSlug"
      :isBookmarked="isBookmarked"
      :isBookmarkedPage="isBookmarkedPage"
    />

    <div class="flex justify-between mt-[8px]">
      <div>
        <p
          v-if="type != 'sm_quotes'"
          class="text-[16px] leading-[20px] font-medium font-aktiv-grotesk"
        >
          {{ title }}
        </p>
      </div>
      <div v-if="!isGPCRPage()">
        <BookMarkButton :bookmark-id="slug" :title="title"></BookMarkButton>
      </div>
    </div>
    <VideoTag
      class="mt-[8px]"
      :is-video="type === 'video'"
      :is-exclusive="isExclusive"
      :is-audio="isAudio"
      :has-chinese-overdub="availTranslations?.hasChineseOverdub"
      :has-thai-overdub="availTranslations?.hasThaiOverdub"
      :has-chinese-sub="availTranslations?.hasTradChiSubtitles"
      :translations="resourceTranslations"
      :type="type"
    />
  </div>
</template>

<script>
import VideoTag from '@/components/ResourcesPage/PlaybackResources/VideoTag.vue';
import ResourceCardThumbnail from '@/components/ResourcesPage/PlaybackResources/ResourceCardThumbnail.vue';
import YoutubeInAppBrowser from '@/components/ResourcesPage/PlaybackResources/YoutubeInAppBrowser.vue';
import BookMarkButton from '@/components/common/BookMarkButton.vue';
import { isGPCRPage, isGICPage } from '@/utils/conference-type';
import { isYoutubeLink, isYoutubeVideoLink, getYoutubeId } from '@/utils/youtube';
import { mapGetters, mapState } from 'vuex';

export default {
  components: { VideoTag, ResourceCardThumbnail, YoutubeInAppBrowser, BookMarkButton },
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    isExclusive: {
      type: Boolean,
      default: false,
    },
    isAudio: {
      type: Boolean,
      default: false,
    },
    availTranslations: {
      type: Object,
      required: false,
      default: () => {},
    },
    resourceTranslations: {
      type: Array,
      default: () => [],
    },
    duration: {
      type: String,
      required: false,
      default: '0:00',
    },
    code: {
      type: String,
      required: false,
      default: '',
    },
    tagSlug: {
      type: String,
      default: '',
    },
    isBookmarkedPage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('user', ['token']),
    ...mapState('filter', ['bookMarkMap']),
    ...mapGetters('profile', ['delegateId']),
    isBookmarked() {
      return this.bookMarkMap?.[this.slug] || false;
    },
    url() {
      if (this.resourceTranslations) {
        return this.resourceTranslations[0].resourceUrl;
      }
      return '';
    },
  },
  methods: {
    openLanguageModal() {
      this.$emit('openLanguageModal');
    },
    isYoutubeVideoLink,
    getYoutubeId,
    isNativeVideoLink(url) {
      return this.type === 'video' && !isYoutubeLink(url);
    },
    isAppRoute(url) {
      return url?.startsWith('/');
    },
    isGPCRPage() {
      return isGPCRPage();
    },
    isGICPage() {
      return isGICPage();
    },
  },
};
</script>
